<ng-container *ngIf="modulePermitted; else moduleNotPermitted">
    <app-bx-notices
        [modules]="[noticeModuleName]"
        [noticeRetrievalMethod]="noticeRetrievalMethod"
        [objectIds]="[job.ID_Job]"
        [hideView]="true"
        [enableDismissAll]="true"
        style="margin-bottom: 20px; display: block"></app-bx-notices>
    <div class="panel panel-white">
        <div class="panel-heading border-light">
            <h4 class="panel-title">{{ 'general.variations' | translate }}</h4>
            <ul class="panel-heading-tabs border-light">
                <li class="d-flex">
                    <div class="input-wrapper">
                        <i class="prefix fa-light fa-magnifying-glass"></i>
                        <input [value]="searchText()" (input)="handleSearchInput($event)" class="text-input" placeholder="Search" />
                        <button
                            id="job-variations-filter-search-reset"
                            class="suffix btn-flat btn-small square"
                            (click)="searchText.set('')">
                            <i class="fa-light fa-xmark"></i>
                        </button>
                    </div>
                </li>
                <li>
                    <div class="btn-group">
                        <button
                            type="button"
                            class="btn-bx-primary"
                            (click)="addVariation()"
                            [disabled]="estimateNotAccepted"
                            tooltip="Add {{ translations.variation }}"
                            container="body"
                            *ngIf="permissionService.isAvailable('jobs.maintain-variations.create-variations')">
                            <i class="ti-plus"></i>
                        </button>
                    </div>
                </li>
                <li *ngIf="job.InvoiceMethod === 1 && job.ID_Estimate">
                    <div class="btn-group dropdown" dropdown>
                        <button type="button" class="btn btn-default dropdown-toggle" dropdownToggle aria-controls="dropdown-settings">
                            <i class="ti-settings"></i> <span class="caret margin-left-5"></span>
                        </button>
                        <ul id="dropdown-settings" class="dropdown-menu dropdown-menu-right no-max-height" role="menu" *dropdownMenu>
                            <li>
                                <a (click)="settings.ShowEstimateTotalOnCostPlusVariation = !settings.ShowEstimateTotalOnCostPlusVariation">
                                    <i *ngIf="settings.ShowEstimateTotalOnCostPlusVariation" class="ti-check"></i> Show estimate total on
                                    printed {{ 'general.variations' | translate }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <div class="panel-body">
            <div class="row" *ngIf="!estimateNotAccepted">
                <div class="col-xs-12">
                    <div class="btn-group btn-group-xs" role="group">
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="!statusFilter().includes('All') ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="setFilter(['All'])">
                            All <span class="badge badge-light-grey">{{ variationCounts().all }}</span>
                        </button>
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="!statusFilter().includes('Pending') ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="setFilter(['Pending'])">
                            Pending <span class="badge badge-light-grey">{{ variationCounts().pending }}</span>
                        </button>
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="!statusFilter().includes('Sent') ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="setFilter(['Sent'])">
                            Sent <span class="badge badge-light-grey">{{ variationCounts().sent }}</span>
                        </button>
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="!statusFilter().includes('Accepted') ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="setFilter(['Digitally Accepted', 'Accepted'])">
                            Accepted <span class="badge badge-light-grey">{{ variationCounts().accepted }}</span>
                        </button>
                        <button
                            type="button"
                            class="mr-1"
                            [ngClass]="!statusFilter().includes('Rejected') ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                            (click)="setFilter(['Rejected'])">
                            Rejected <span class="badge badge-light-grey">{{ variationCounts().rejected }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="table-wrapper margin-top-15" *ngIf="!estimateNotAccepted" #tableWrapper>
                <ngx-datatable
                    [ngStyle]="{ height: tableHeight }"
                    #variationsTable
                    class="material bxt-table"
                    [rows]="rows()"
                    [rowHeight]="40"
                    [scrollbarV]="true"
                    columnMode="force"
                    [headerHeight]="50"
                    [virtualization]="false"
                    [footerHeight]="50"
                    [limit]="100"
                    [sorts]="[{ prop: 'VariationDate', dir: 'desc' }]">
                    <!-- columns -->
                    <ngx-datatable-column name="{{ translations.variationTitle }}" prop="VariationNo" [flexGrow]="1" [minWidth]="95">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a
                                class="bxt-row-action"
                                [ngClass]="{ 'disabled-link': !permissionService.isAvailable('jobs.maintain-variations.view-variations') }"
                                (click)="viewVariation(row)">
                                {{ row.VariationNo }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Description" prop="Description" [flexGrow]="8">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a
                                class="bxt-row-action"
                                [ngClass]="{ 'disabled-link ': !permissionService.isAvailable('jobs.maintain-variations.view-variations') }"
                                (click)="viewVariation(row)">
                                {{ row.Description }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Type" prop="IsAdjustment" [flexGrow]="4" *ngIf="showAdjustment">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.IsAdjustment ? variationTypeLabel.adjustment : variationTypeLabel.variation }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Created" prop="VariationDate" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.VariationDate | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Start" prop="StartDate" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.StartDate | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Total" prop="TotalIncTax" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.TotalIncTax | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Status" prop="Status" [flexGrow]="2">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span
                                class="label"
                                [ngClass]="{
                                    'label-inverse': row.Status === 'Pending',
                                    'label-warning': row.Status === 'Sent',
                                    'label-success': row.Status === 'Accepted' || row.Status === 'Digitally Accepted',
                                    'label-danger': row.Status === 'Rejected',
                                }">
                                {{ row.Status }}</span
                            >
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Invoice #" [flexGrow]="3" *ngIf="job.InvoiceMethod !== 1">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <ng-container *ngFor="let invoice of row.invoices">
                                <a class="bxt-row-action" style="margin-right: 8px" (click)="viewInvoice(invoice)">{{
                                    invoice.InvoiceNumberString
                                }}</a>
                            </ng-container>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                        [width]="160"
                        [sortable]="false"
                        [canAutoResize]="false"
                        [draggable]="false"
                        [resizeable]="false"
                        [cellClass]="'right-align'"
                        [headerClass]="'disabled'">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button
                                type="button"
                                class="btn btn-xs btn-default"
                                (click)="shareVariation(row)"
                                tooltip="Share"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="featureService.isAvailable('clientportal')"
                                [disabled]="!permissionService.isAvailable('leads.maintain-leads.client-portal-publish')">
                                Share
                            </button>
                            <button
                                (click)="printVariation(row)"
                                class="btn btn-xs btn-default margin-left-5"
                                tooltip="Print {{ row.IsAdjustment ? translations.adjustment : translations.variation }}"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="permissionService.isAvailable('jobs.maintain-variations.print-email-variation')">
                                <i class="ti-printer"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-danger margin-left-5"
                                (click)="deleteVariation($event, row)"
                                tooltip="Delete {{ row.IsAdjustment ? translations.adjustment : translations.variation }}"
                                container="body"
                                [adaptivePosition]="false"
                                [disabled]="row.ID_JobPayment || row.Status !== 'Pending'"
                                *ngIf="permissionService.isAvailable('jobs.maintain-variations.delete-variation')">
                                <i class="ti-trash"></i>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>

            <div class="col-xs-12 text-center" *ngIf="estimateNotAccepted">
                <h2 class="margin-top-30 margin-bottom-30">
                    You&rsquo;re still working on your estimate.<br />Once it&rsquo;s accepted, you&rsquo;ll be able to create
                    {{ 'general.variations' | translate | lowercase }}.
                </h2>
                <p class="text-normal">
                    Need help with this?
                    <a href="http://help.buildxact.com/en/articles/3038643-i-ve-created-a-job-why-can-t-i-create-variations" target="_blank"
                        >Click here for more information</a
                    >
                </p>
            </div>
        </div>
    </div>

    <help-note-wrapper
        [title]="'helpNotes.jobs.variations.title' | translate"
        [url]="'helpNotes.jobs.variations.url' | translate"
        footer="Read more in our FAQ’s"
        setting="NoteJobVariationList"
        [expanded]="true"
        [videoUrl]="'helpNotes.jobs.variations.video-url' | translate">
        {{ 'helpNotes.jobs.variations.text' | translate }}
    </help-note-wrapper>
</ng-container>

<ng-template #moduleNotPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
